/*
 *  IRIS Interactive
 *
 *  NOTICE OF LICENSE
 *  This source file is no subject to a specific license
 *  but it belongs to the company IRIS Interactive.
 *  You can contact IRIS Interactive at the following
 *  address: contact@iris-interactive.fr
 *
 *  @author      Vincent RIBANO
 *  @date        19/9/2022 12:18
 *  @copyright   Copyright (c) 2002-2022 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

import AnchorsService from "./services/anchors.service"
import CollapseService from "./services/collapse.service"
import CursorEffectService from "./services/cursor-effect.service"
import RippleEffectService from "./services/ripple-effect.service"
import ScrollRevealService from "./services/scroll-reveal.service"
import ScrollspyService from "./services/scrollspy.service"
import SliderService from "./services/slider.service"

export default function initUIScripts() {
    new SliderService()
    new CollapseService()
    new RippleEffectService()
    new CursorEffectService()
    new AnchorsService()
    new ScrollspyService()
    new ScrollRevealService()
}
